import React from 'react';

import GenericSpinner from './GenericSpinner';
import { getColorsForMinimalLoader } from './spinnerUtil';

interface MinimalLoaderProps {
    className?: string;
    ariaLabel?: string;
    mini?: boolean;
}

const SimpleSpinner: React.FC<MinimalLoaderProps> = ({ className, ariaLabel = 'Vent litt', mini = false }) => (
    <GenericSpinner
        className={className}
        ariaLabel={ariaLabel}
        colors={getColorsForMinimalLoader()}
        roundedEdges={false}
        mini={mini}
    />
);

export default SimpleSpinner;
